<template>
  <v-sheet class="mt-5 pa-5" tile>
    <v-subheader class="text-h5 pa-0 pb-4">{{
      $t('BUILDING_COMPLEXES.BUSINESS_CUSTOMERS')
    }}</v-subheader>
    <v-data-table
      :headers="headers"
      :items="items"
      :sort-desc="true"
    >
      <template v-slot:item.apartments_number="{ item }">
        {{ item.apartments_number }} ({{ item.apartments_free_number }})
      </template>
    </v-data-table>
  </v-sheet>
</template>

<script>
export default {
  name: 'HabitationList',

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER'),
          value: 'name'
        },
        {
          text:
            this.$t('APARTMENTS.ITEMS') +
            ' (' +
            this.$t('APARTMENTS.FREE') +
            ')',
          value: 'apartments_number'
        },
        {
          text: this.$t('INHABITANTS.ITEMS'),
          value: 'inhabitants_number'
        },
        {
          text: this.$t('BUILDINGS.ITEMS'),
          value: 'buildings_number'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEMS'),
          value: 'building_complexes_number'
        }
      ];
    }
  }
};
</script>
